import axios from 'axios';
import { $Q } from '../utils/querySelector';
import { currentLangNow } from '../utils/getLanguage';

let submitnewsletterform = $Q('#submit-newsletter-form');
let btnsubmit = $Q('#btn-submit-newsletter');

//initNewsletterForm();

/**
 * Register Email In Klaviyo by API
 */
async function registerEmailInKlaviyo(email, language) {
  const config = {
    params: { company_id: 'SAYRNQ' },
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json',
      revision: '2024-02-15',
    },
  };

  const data = {
    data: {
      type: "profile",
      attributes: {
        email,
      },
      properties: {
        preferred_language: language,
      },
    },
  };

  try {
    const response = await axios.post(
      'https://a.klaviyo.com/client/profiles',
      data,
      config
    );
    console.log('Email registered successfully:', response);
  } catch (error) {
    console.error('Error registering email:', error);
  }
}

if (btnsubmit) {
  /*
 * Function before form submit
 */
  btnsubmit.addEventListener('click', function () {
    let inputsubmit = $Q('#input-email-newsletter').value;
    let language = currentLangNow();
    registerEmailInKlaviyo(inputsubmit, language);
    restoreNewsletterForm();
    btnsubmit.click();
  });

}

/*
 * Disable attributes of form
 */
function initNewsletterForm() {
  if (submitnewsletterform) {
    submitnewsletterform.setAttribute('action', '');
    submitnewsletterform.setAttribute('method', '');
  }
}

/*
 * Restore attributes of form
 */
function restoreNewsletterForm() {
  if (submitnewsletterform) {
    submitnewsletterform.setAttribute('action', '/contact#');
    submitnewsletterform.setAttribute('method', 'post');
  }
}
